import { render, staticRenderFns } from "./ButtonPreview.vue?vue&type=template&id=aacbb716&scoped=true&"
import script from "./ButtonPreview.vue?vue&type=script&lang=js&"
export * from "./ButtonPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacbb716",
  null
  
)

export default component.exports